import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-pago-confirmado',
  templateUrl: './pago-confirmado.component.html',
  styleUrls: ['./pago-confirmado.component.scss']
})
export class PagoConfirmadoComponent implements OnInit {
  verificando = true;
  confirmado = false;
  error = '';
  montoPagado = 0;
  moneda = 'MXN';

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    const chargeId = this.route.snapshot.queryParamMap.get('id') || this.route.snapshot.queryParamMap.get('charge_id');
    if (!chargeId) {
      this.verificando = false;
      this.error = 'No encontramos el identificador del pago.';
      return;
    }
    this.confirmarPago(chargeId);
  }

  private headers(): HttpHeaders {
    return new HttpHeaders({
      Accept: 'application/json',
      Authorization: localStorage.getItem('token') || ''
    });
  }

  private confirmarPago(chargeId: string): void {
    const url = environment.BASE_URL + '/api/pago/openpay/confirmar/?id=' + encodeURIComponent(chargeId);
    this.http.get<any>(url, {headers: this.headers()}).subscribe(
      response => {
        this.verificando = false;
        this.confirmado = true;
        this.montoPagado = Number(response.amount) || 0;
        this.moneda = response.currency || 'MXN';
      },
      response => {
        this.verificando = false;
        this.error = response.error && response.error.error ? response.error.error : 'No fue posible confirmar el pago.';
      }
    );
  }

  irAlPerfil(): void {
    this.router.navigate([this.paymentRoutePrefix() === '/cliente' ? '/cliente/seguimiento' : '/perfil']);
  }

  volverAlPago(): void {
    this.router.navigate([this.paymentRoutePrefix() + '/realizar-pago']);
  }

  cerrarSesion(): void {
    localStorage.removeItem('token');
    this.router.navigate(['/']);
  }

  private paymentRoutePrefix(): string {
    return this.router.url.indexOf('/cliente/') === 0 ? '/cliente' : '/perfil';
  }
}
